import React, { useState } from 'react'
import Actions from './Actions'
import { useApp, useProject } from 'hooks';
import { projectLabels, projectStatusVal, repareURL } from 'utils';
import { User } from 'lucide-react';
import { BottomModal, CenteredModal } from 'components';
import ProjectForm from 'pages/projects/ProjectForm';
import { useNavigate } from 'react-router-dom';

export default function ContentDetail() {
    const router = useNavigate()
    const { projectDetail: item, projectIsFetch, onUpdateParams } = useApp();
    const { delProj } = useProject()
    const [action, setAction] = useState('')
    const { trans } = useApp();

    const onRedirect = () => {
        onUpdateParams({ projectIsFetch: !projectIsFetch })
        router(-1);
    }

    const handleActions = (act) => {
        switch (act) {
            case 'edit':
            case 'delete':
                setAction(act)
                break;
            case 'confirmDel':
                delProj.mutate({ id: item.id }, {
                    onSuccess: () => {
                        onRedirect();
                    },
                })
                break;
            default:
                break;
        }
    }

    const onClose = () => {
        setAction('')
    }

    return (<>
        <div className="flex items-start justify-between">
            <div>
                <h2 className="text-xl font-semibold">{item?.name}</h2>
                <span
                    className={`inline-block text-xs px-2 py-1 rounded-md font-semibold mb-2 ${projectLabels[item?.status]}`}
                >
                    {projectStatusVal[item?.status]}
                </span>

            </div>
            <Actions onChange={handleActions} />
        </div>
        <div className="text-gray-600 text-sm mt-4 space-y-2">
            <div dangerouslySetInnerHTML={{ __html: item?.content }}></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-6 text-sm text-gray-700">
            <div>
                <div className="font-medium">Ngày bắt đầu:</div>
                <div className="font-bold text-base">{item?.start_date}</div>
            </div>
            <div>
                <div className="font-medium">Ngày kết thúc:</div>
                <div className="font-bold text-base">{item?.due_date}</div>
            </div>
            <div>
                <div className="font-medium">Tổng số nhiệm vụ:</div>
                <div className="font-bold text-base">{item?.total_task}</div>
            </div>
        </div>

        <div className="mt-6">
            <div className="font-medium mb-2">Thành viên:</div>
            {!!item?.members?.length && <div className="flex -space-x-3">
                {[...Array(Math.min(item?.members?.length, 3))].map((_, i) => item?.members[i]?.avatar ? (
                    <img
                        key={i}
                        src={repareURL(item?.members[i]?.avatar)}
                        className="w-9 h-9 rounded-full border-2 border-white"
                        alt="user"
                    />
                ) : <User key={i} className="w-9 h-9 rounded-full border-2 border-gray" />)}
            </div>}
        </div>
        {action === 'edit' && <BottomModal title={`${trans(action)} dự án`} onClose={onClose} >
            <ProjectForm onClose={onClose} item={item} />
        </BottomModal>}
        {(['delete'].includes(action)) && <CenteredModal type={action} title={`${trans(action)} dự án`} description='Bạn có chắc muốn xoá dự án này không?' onClose={onClose} onConfirm={() => handleActions('confirDel')} />}
    </>)
}
